import(/* webpackMode: "eager" */ "/app/src/app/[countryCode]/(main)/cookies/page.tsx");
